import { Stack } from "@mui/material";
import { Link } from "@mui/material";
import { ZoomInMap } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../Redux/redux-store";
import { ToggleEnlargePanel } from "../../../Redux/Reducers/redux-slice-drive";
import { DriveBreadcrumbs } from "../Common/drive-breadcrumbs";
import AssetSinglePreview, {
  PreviewContext,
} from "../../../Pages/admin/Inventory/InventoryAssetSingle/AssetSinglePreview/asset-single-preview";
import { useEffect, useRef } from "react";
import { GetPlayerInfos, SetPlayerHeight, SetPlayerResponsive } from "../../../Redux/Reducers/redux-slice-layout";

export const DriveEnlargedPanel = () => {
  const { t } = useTranslation();
  const panelHeaderRef = useRef<HTMLDivElement>(null);

  // Redux
  const dispatch = useAppDispatch();
  const { containerHeight, height } = useAppSelector(GetPlayerInfos);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((event) => {
      dispatch(SetPlayerHeight(containerHeight - event[0].contentBoxSize[0].blockSize));
      dispatch(SetPlayerResponsive(false));
    });

    if (panelHeaderRef.current) resizeObserver.observe(panelHeaderRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [containerHeight]);

  return (
    <>
      <Stack direction="row" justifyContent={"space-between"} px={2} ref={panelHeaderRef}>
        <DriveBreadcrumbs />

        <Link
          href="#"
          underline="hover"
          variant="body1"
          color="primary.text"
          sx={{ flexGrow: 0 }}
          onClick={(e) => dispatch(ToggleEnlargePanel())}
        >
          <>
            <ZoomInMap sx={{ mr: 0.5 }} />
            {t("common:reduce")}
          </>
        </Link>
      </Stack>
      <AssetSinglePreview context={PreviewContext.DriveEnlarged} />
    </>
  );
};
